import React, { useState, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import { WrappedMenu } from '../components/new/Menu';
import { CustomBreadCrumbs } from '../components/new/CustomBreadCrumbs';
import { BlogCardsComponent } from '../components/new/BlogCardsComponent';
import { Footer } from '../components/new/Footer';
import { SEO } from '../components/seo';
import { PrimaryButton } from '../components/new/Pages';

import { Wrap } from '../components/new/Wrap';
import { BaseHeadingStyle } from '../components/new/headers';

const Container = styled.div`
    position: relative;
    max-width: 1360px;
    padding: 0 24px;
    margin: 0 auto;
    box-sizing: border-box;

    .blog-cards__card-wrapper {
    }

    .blog-cards__card-wrapper.wide {
    }
`;

const H1 = styled(BaseHeadingStyle)`
    font-size: 80px;
    line-height: 100%;
    margin: 48px 0;
    position: relative;
    left: -3px;
    max-width: 980px;

    @media screen and (max-width: 760px) {
        font-size: 38px;
        margin: 16px 0 24px;
    }
`;

export const blogQuery = graphql`
    query BlogPosts {
        allMarkdownRemark(
            limit: 1000
            sort: { fields: frontmatter___date, order: DESC }
        ) {
            nodes {
                small: cloudImage {
                    fluid(
                        transformations: [
                            "ar_5:2"
                            "c_fill"
                            "g_auto"
                            "f_auto"
                        ]
                    ) {
                        ...CloudinaryAssetFluid
                    }
                }
                medium: cloudImage {
                    fluid(transformations: ["ar_2.83", "c_fill", "g_auto"]) {
                        src
                    }
                }
                smallBackground: cloudImage {
                    fluid(transformations: ["ar_1.12", "c_fill", "g_auto"]) {
                        src
                    }
                }
                frontmatter {
                    url
                    title
                    date
                }
                id
            }
        }
    }
`;

const BlogPage = ({ pageContext, data }) => {
    const [postsCount, setPostsCount] = useState(8);
    const {
        breadcrumb: { crumbs },
    } = pageContext;

    const { nodes: posts } = data.allMarkdownRemark;

    const filteredPosts = useMemo(() => {
        return posts.slice(0, postsCount);
    }, [postsCount, posts]);
    const onClickMore = useCallback(() => {
        setPostsCount(postsCount + 9);
    }, [postsCount]);
    return (
        <Wrap>
            <SEO title="КЭСПА Блог" description="КЭСПА Блог" />

            <Container>
                <WrappedMenu />

                <CustomBreadCrumbs crumbs={crumbs} />
                <H1 as="h1">КЭСПА Блог</H1>

                <BlogCardsComponent postsArray={filteredPosts} />
                {postsCount < posts.length && (
                    <PrimaryButton onClick={onClickMore} className="centered">
                        Показать ещё
                    </PrimaryButton>
                )}
            </Container>

            <Footer />
        </Wrap>
    );
};

export default BlogPage;
